module.exports = __webpack_public_path__ + "img/沙河玻璃.9136c5d8.jpg";